import React from 'react'
import { color } from 'styles'
import font from 'styles/font'
import { withProps } from 'recompose'

const iconSize = size => font.size[size] || size || '1.5rem'

const Svg = ({ size, viewBox = '0 0 512 512', ...props }) => (
  <svg
    viewBox={viewBox}
    style={{
      width: iconSize(size),
      height: iconSize(size),
      fill: color(props.fill) || 'currentColor',
      stoke: 'currentColor' || props.stoke,
      stokeLinecap: 'round',
      stokeLinejoin: 'round',
      pointerEvent: props.pointerEvent,
      verticalAlign: 'middle'
    }}
    {...props}
  />
)

export default withProps({
  xmlns: 'http://www.w3.org/2000/svg'
})(Svg)
